import React, { useEffect, useState } from 'react';

import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Alert, Box, styled } from '@mui/material';

import { Formik, Form } from 'formik';
import yup from '../../../commons/validators/customYup';
import SuperUserService from '../../../services/SuperUserService';
import showNotification from '../../../commons/helpers/showNotification';
import { FormTextField } from '../../../components/forms/FormikFields';

const DialogActionsStyled = styled(DialogActions)(() => ({ justifyContent: 'space-between' }));

const schema = yup.object().shape({
  email: yup.string().email().max(100),
});

const DEFAULT_INIT_VALUES = {
  email: '',
};

// COMPONENT
function EditCompanyEmailModal({ selectedCompany, modalVisible, setModalVisible, onSave }) {
  const [initialValues, setInitialValues] = useState(DEFAULT_INIT_VALUES);

  useEffect(() => {
    if (modalVisible) {
      setInitialValues({
        email: selectedCompany.email ?? '',
        timestamp: new Date().getTime(),
      });
    }
  }, [modalVisible, selectedCompany]);

  const myHandleSubmit = (values, actions) => {
    SuperUserService.updateEmailAddress({
      email: values.email,
      companyId: selectedCompany.id,
    })
      .then(() => {
        showNotification('success', 'Atualizado com successo.');
        onSave({ email: values.email });
      })
      .finally(() => {
        actions.setSubmitting(false);
      });
  };

  const handleClose = () => {
    setModalVisible(false);
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={modalVisible} fullWidth>
      <DialogTitle variant="h5">Atualizar Email da empresa - {selectedCompany.name}</DialogTitle>

      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={myHandleSubmit}
      >
        {({ dirty, isSubmitting }) => (
          <Form>
            <DialogContent dividers>
              <Box>
                <Alert severity="info">
                  Atualizar o email da empresa também atualizará o email do usuário master e fará com que ele
                  tenha que fazer um novo login.
                </Alert>
                <FormTextField fullWidth type="email" label="Email" name="email" />
              </Box>
            </DialogContent>

            <DialogActionsStyled>
              <Button variant="outlined" onClick={handleClose}>
                Fechar
              </Button>
              <Button variant="contained" type="submit" color="primary" disabled={!dirty || isSubmitting}>
                Salvar
              </Button>
            </DialogActionsStyled>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}

export default EditCompanyEmailModal;
